import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/server/app/apps/pcc-nextjs-bff/app/[lang]/[esite]/(core)/(home)/_components/customer-account/section-loader/section-loader.tsx");
;
import(/* webpackMode: "eager" */ "/usr/server/app/apps/pcc-nextjs-bff/app/[lang]/[esite]/(core)/(home)/_components/shop-by-category/shop-by-category-loader/shop-by-category-loader.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/server/app/apps/pcc-nextjs-bff/app/[lang]/[esite]/(core)/(home)/_components/cat-value/cat-value.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/server/app/apps/pcc-nextjs-bff/components/blocks-components.tsx");
